import { useCallback } from "react";

import { API_EQUIPMENT, BASE_ADMIN } from "../constants/api";
import { EquipmentData } from "./useEquipment";
import { canAccessAdminDashboard } from "../utils/roles";
import useRequest from "./useRequest";
import useAuth from "./useAuth";

type LastEquipmentsResponse = {
  data: EquipmentData[];
};

const useLastEquipments = () => {
  const { user } = useAuth();
  const canAccess = canAccessAdminDashboard(user?.role);

  const { error, isLoading, response, request } = useRequest<LastEquipmentsResponse>();

  const fetchLastEquipments = useCallback(() => {
    if (!canAccess) return;

    request(BASE_ADMIN, API_EQUIPMENT, {
      secure: true,
      searchParams: { limit: "3" }
    });
  }, [canAccess, request]);

  return {
    isLoading,
    error,
    lastEquipments: response?.data ?? null,
    fetchLastEquipments
  };
};

export default useLastEquipments;
